import { nextFrame as c } from "./dom.js";
async function M({ element: t, offset: n = 32, aspectRatio: d, maxScale: h, forceWidthFit: p = !1 } = {}) {
  let o = 1;
  if (!t.parentElement)
    return;
  t.parentElement.style.overflow = "hidden", ["relative", "absolute", "fixed"].indexOf(
    window.getComputedStyle(t.parentElement, null).getPropertyValue("position")
  ) === -1 && (t.parentElement.style.position = "relative"), t.style.position = "absolute", t.style.transformOrigin = "left top", await c();
  let i = t.offsetWidth;
  const r = t.offsetHeight;
  let a = t.parentElement.offsetWidth, e = t.parentElement.offsetHeight;
  a -= n, e -= n, d && (i = Math.max(i, Math.round(r * d)), t.style.width = `${i}px`);
  const s = a / i, f = e / r;
  p ? o = s : o = s < f ? s : f, h && (o = Math.min(o, h));
  const g = Math.round(i * o), y = Math.round(r * o);
  e += n, a += n;
  const u = 17;
  let l = Math.round((e - y) * 0.5);
  p && l < u && (l = u), t.style.transform = `scale(${o})`, t.style.left = `${Math.round((a - g) * 0.5)}px`, t.style.top = `${l}px`;
}
export {
  M as scaleToFit
};
//# sourceMappingURL=scale-to-fit.js.map
